import React from "react"
import { Container, FlexContainer, Stack, Text } from "@carrotfertility/carotene"
import ArrowSubmitButton from "../../../../features/legacy-components/ArrowSubmitButton"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import queryString from "query-string"
import { Steps } from "../workflow"
import { CaseRateRenewalModalTopSection } from "../CaseRateRenewalModalTopSection"
import { FormattedMessage, useIntl } from "react-intl"

export function WelcomeBackIntroStep(): JSX.Element {
  const intl = useIntl()
  const { step } = queryString.parse(window.location.search)
  const { send } = useStateMachine(step === Steps.WELCOME_BACK_INTRO || !step ? null : "")

  return (
    <Container alignItems="center">
      <CaseRateRenewalModalTopSection
        header={intl.formatMessage({
          defaultMessage: "Welcome back"
        })}
        showImage
        imageAltText={intl.formatMessage({
          defaultMessage: "carrot logo watering can"
        })}
        imageSrc="/images/carrot-logo-watering-can"
      />
      <Stack stack="huge">
        <Text>
          <FormattedMessage defaultMessage="It’s been a while since we last refreshed your Carrot Plan with new suggestions. We want to make sure it is best serving you and your journey." />
        </Text>
        <Text>
          <FormattedMessage defaultMessage="Please take a couple minutes to update us." />
        </Text>
      </Stack>
      <FlexContainer sx={{ position: "fixed", bottom: [24, 48], right: [24, 48] }}>
        <ArrowSubmitButton onClick={() => send("")}>
          <FormattedMessage defaultMessage="Continue" />
        </ArrowSubmitButton>
      </FlexContainer>
    </Container>
  )
}
